import Structure from '../modules/structure';

$.fn.mainSliderScript = function(options) {

    var jqAllAffectedContainers = this;

    jqAllAffectedContainers.each(function() {
        const container = $(this);
        const structure = new Structure('commonSwiperSlider', container, {
           contentSlider: ".content-slider-block",
           selectorSlider: ".selector-slider",
           contentNav: ".content-slider-block .nav"
        }).structure;

        const selectorSliderObj = new Swiper(structure.selectorSlider.get(0), {
            direction: 'vertical',
            effect: 'slide',
            slidesPerView: 3,
            spaceBetween: 8,
            watchSlidesProgress: true,
            navigation: {
                
            },
            breakpoints: {
                320: {
                    
                },
                768: {
                    
                },
                1200: {
                    
                },
                1540: {
                    
                }
            }
        });

        const contentSliderObj = new Swiper(structure.contentSlider.get(0), {
            slidesPerView: 1,
            spaceBetween: 0,
            thumbs: {
                swiper: selectorSliderObj,
                autoScrollOffset: 1
            },
            navigation: {
                
            },
            pagination: {
                el: structure.contentNav.get(0),
                clickable: true
            },
            breakpoints: {
                320: {
 
                },
                768: {
   
                },
                1200: {
                    
                },
                1540: {
                    
                }
            }
        });

 
    });

    return this;
};

document.addEventListener('DOMContentLoaded', function() {
    $('.main-slider-js').mainSliderScript();
});